import Guidelines from 'design/Guidelines';
import DatadogUtil from 'performance/DatadogUtil';
import {RouteBundle} from 'routing/RouteConstants';
import {renderReactComponent} from 'util/RootReactRender';

export const DesignRoutes: RouteBundle = {
  domain: 'design',
  routes: [{urlPattern: '_design/:component', handler: design, legacy: true}],
};

function design(component: string): void {
  DatadogUtil.startRUMView('design');
  renderReactComponent(Guidelines, {component});
}
